<template lang="pug">
table-base.study-result-resolve-table
  //- ヘッダー部
  table-row-base.study-result-resolve-table__row-header.text-medium
    table-header-base.study-result-resolve-table__row-header__cell.align-center
      slot(name='problemNumberHeader')
    table-header-base.study-result-resolve-table__row-header__cell.align-center
      slot(name='questionNumberHeader')
    table-header-base.study-result-resolve-table__row-header__cell.align-center
      slot(name='questionTypeHeader')
    table-header-base.study-result-resolve-table__row-header__cell.align-center
      slot(name='correctAnswerHeader')
    table-header-base.study-result-resolve-table__row-header__cell.align-center
      slot(name='correctSymbolHeader')
    table-header-base.study-result-resolve-table__row-header__cell.align-center
      slot(name='resolveCorrectSymbolHeader')
  template(v-for='detail in studyResultResolves')
    //- 一覧表示部
    table-row-base.study-result-resolve-table__row.text-small.font-medium
      table-data-base.study-result-resolve-table__row__cell
        .study-result-resolve-table__row__cell__text-left {{ detail.problemNumberText }}
      table-data-base.study-result-resolve-table__row__cell
        .study-result-resolve-table__row__cell__text {{ detail.questionNumberText }}
      table-data-base.study-result-resolve-table__row__cell
        .study-result-resolve-table__row__cell__text {{ detail.questionType }}
      table-data-base.study-result-resolve-table__row__cell
        .study-result-resolve-table__row__cell__text(v-html='detail.correctAnswer')
      table-data-base.study-result-resolve-table__row__cell
        .study-result-resolve-table__row__cell__text {{ detail.correctSymbol }}
      table-data-base.study-result-resolve-table__row__cell
        .study-result-resolve-table__row__cell__text(:data-changed='detail.isChanged') {{ detail.resolveCorrectSymbol }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import { StudyResultResolveType } from '@/models/studyResultDetailModel'

/**
 * テスト結果解きなおし詳細テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
  },
})
export default class StudyResultResolveTable extends Vue {
  // テスト結果解きなおし詳細表示情報
  @Prop()
  studyResultResolves!: StudyResultResolveType[]
}
</script>

<style lang="stylus" scoped>
.study-result-resolve-table
  width 100%
  table-layout fixed

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__text
        display flex
        justify-content center

        &[data-changed='true']
          color var(--color-manager-list-alert__text)

    &:hover
      background var(--color-manager-list__hover)
</style>
